module.exports = __webpack_public_path__ + "img/brand-bq5.77e3edd7.png";